import { queryClient } from '@/utils/reactQueryClient';
import { createCompanyController } from '@saas/api-client';
import { globalAuthRequestFunction } from '../http/request';
import { makeMutation, makeQuery } from '../http/queryUtils';

const companyController = createCompanyController(globalAuthRequestFunction);

const gettingStartedKeys = {
	base: 'GETTING_STARTED',
	mine: () => [gettingStartedKeys.base, 'MINE'] as const,
};

const invalidate = {
	all: () => queryClient.invalidateQueries({ queryKey: [gettingStartedKeys.base] }),
	mine: () => queryClient.invalidateQueries({ queryKey: gettingStartedKeys.mine() }),
};

const useGetMyGettingStarted = makeQuery({
	queryFunction: companyController.getMyGettingStarted,
	queryKeyFactory: () => [...gettingStartedKeys.mine()],
});

const useCompleteStep = makeMutation({
	mutationFunction: companyController.completeMyGettingStartedStep,
	onSuccess: () => invalidate.mine(),
});

const useDismiss = makeMutation({
	mutationFunction: companyController.dismissMyGettingStarted,
	onSuccess: () => invalidate.mine(),
});

export const gettingStartedService = {
	useGetMyGettingStarted,
	useCompleteStep,
	useDismiss,
	invalidate,
};
